import { Dictionary } from '@reduxjs/toolkit';

interface OriginItem {
  id: number;
}

// Used for v2 compatibility for normalize the data
export const normalizeItems = <T extends OriginItem>(itemsArray: Array<T>) => {
  const normalizedObject = {};

  itemsArray.forEach(item => {
    normalizedObject[item.id] = item;
  });

  return normalizedObject;
};

// Extracts entities ids into array
export const extractIds = entities => {
  if (!entities) {
    return;
  }

  return entities.map(entity => entity.id);
};
